import comp from "./VerifyOtpModal";
export default comp;
